const types = {
  documents: 'documents',
  document: 'document',
}

export default types;
